export default __webpack_public_path__ + "static/media/chevron-down_sm.5c6065f6.svg";